// extracted by mini-css-extract-plugin
export default {"mobilePreview":"mobilepreview_mobilePreview__LEEJx"};